export default {
    it: {
        "related-questions": "Domande correlate:"
    },
    en: {
        "related-questions": "Related questions:"
    }
}